import { Refresh } from "heroicons-react";

export default function LoadingIndicator({ className, ...rest }: { className?: string; [key: string]: any }) {
  return <Refresh {...rest} className={`animate-spin ${className}`} size={16} />;
}
